import { render, staticRenderFns } from "./SkillCreate.vue?vue&type=template&id=7390dff3"
import script from "../../controllers/skill/skill-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/skill/skill-create.js?vue&type=script&lang=js&external"
import style0 from "./SkillCreate.vue?vue&type=style&index=0&id=7390dff3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports